import utils from '@/util/index';
import { resourceRequest } from '@/network/request';
let axios = resourceRequest();

//导出
export { resourceRequest };

// /* 请求拦截器 */
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return error;
  }
);

// /* 响应拦截器 */
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return error;
  }
);

export function get(url, params = {}) {
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params,
  });
}

//第三方回调使用
export function get1(url, params = {}) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return axios({
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    url: url,
    params,
  });
}

//常用post请求  数据未JSON化
export function post(url, data) {
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: data,
  });
}

//put请求数据JSON化
export function put(url, data) {
  return axios({
    url: url,
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: JSON.stringify(data),
  });
}

export function deletes(url, data) {
  return axios({
    url: url,
    method: 'delete',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data,
  });
}
